import React, { createContext, useContext } from "react";
import { useThaloWeb } from "@/contexts/ThaloWebContext";
import { InstallationData } from "@/installation/installation";

type AllAssetsContextType = {
  allAssets: InstallationData[]
};

const AllAssetsContext = createContext<AllAssetsContextType | undefined>(undefined);

export function AllAssetsContextProvider({ children }: any) {
  const { selectedLocation } = useThaloWeb();

  const allAssets = selectedLocation ? selectedLocation?.installation_set : [];

  return (
    <AllAssetsContext.Provider
      value={{
        allAssets
      }}
    >
      {children}
    </AllAssetsContext.Provider>
  );
}

type useAllAssetsOptions = {
  filterPredicate?: (asset: InstallationData) => boolean
}

const defaultUseAllAssetsOptions: useAllAssetsOptions = {
  filterPredicate: undefined
}

export function useAllAssets({ filterPredicate }: useAllAssetsOptions = defaultUseAllAssetsOptions) {
  const context = useContext(AllAssetsContext);
  if (context === undefined) {
    throw new Error("AllAssets Context must be used within its provider");
  }

  if (filterPredicate) {
    return {
      ...context,
      allAssets: context.allAssets.filter((asset) => filterPredicate(asset))
    }
  } else {
    return context;
  }
}
